module.exports = __webpack_public_path__ + "img/step2.a83a3be2.png";